<template>
  <div>
    <ValidationObserver ref="observer">
      <template v-if="input.receive_type == 'bank_account'">
        <ValidationProvider
          name="บัญชีธนาคาร"
          :rules="{
            required: true,
            min: 13,
          }"
          v-slot="{ errors, valid }"
        >
          <div class="mb-4">
            ยืนยันขอรับเงินผลประโยชน์ตามกรมธรรม์ผ่านบัญชีธนาคาร
            <span class="red--text">*</span>
            <v-select
              dense
              :items="bankOptions"
              v-model="input.bank_account_bank"
              maxlength="13"
              label
              outlined
              :error-messages="errors"
              :success="valid"
              :hide-details="errors.length == 0"
            ></v-select>
          </div>
        </ValidationProvider>
      </template>

      <div class="mb-4">
        <div class="font-weight-bold">
          ชื่อบัญชี <span class="red--text">*</span>
        </div>
        <div style="font-size: 13px" class="red--text">
          ต้องเป็นชื่อผู้เอาประกันภัย (หากเป็นผู้เยาว์ต้องเป็นชื่อผู้ชำระเบี้ย)
        </div>
        <ValidationProvider
          name="ชื่อบัญชี"
          :rules="{ required: true }"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            dense
            v-model="input.bank_account_name"
            label
            outlined
            :error-messages="errors"
            :success="valid"
            :hide-details="errors.length == 0"
          ></v-text-field>
        </ValidationProvider>
      </div>
      <div class="mb-4" v-if="input.receive_type == 'bank_account'">
        <div class="font-weight-bold">
          เลขที่บัญชี <span class="red--text">*</span>
        </div>
        <ValidationProvider
          name="เลขที่บัญชี"
          :rules="{ required: true, max: 15 }"
          v-slot="{ errors, valid }"
        >
          <v-text-field
            dense
            v-model="input.bank_account_number"
            label
            type="text"
            pattern="\d*"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            outlined
            :error-messages="errors"
            :success="valid"
            maxlength="15"
            :hide-details="errors.length == 0"
          ></v-text-field>
        </ValidationProvider>
      </div>
      <div class="mb-4">
        <div class="font-weight-bold">เลขบัตรประจำตัวประชาชน</div>
        <v-text-field
          dense
          v-mask="'X-XXXX-XXXXX-XX-X'"
          :value="input.card_number"
          label
          outlined
          hide-details
          readonly
        ></v-text-field>
      </div>
      <div class="mb-4">
        <div>ยืนยันการร้องขอสำหรับกรมธรรม์ของผู้เอาประกันภัย</div>
        <v-radio-group color="primary" v-model="input.all_insurance">
          <v-radio class="mb-4" color="primary" value="all">
            <template v-slot:label>
              <div style="color: black; font-size: 19px">สำหรับทุกกรมธรรม์</div>
            </template>
          </v-radio>
          <v-radio color="primary" value="single">
            <template v-slot:label>
              <div style="color: black; font-size: 19px">
                สำหรับกรมธรรม์เลขที่
              </div>
            </template></v-radio
          >
        </v-radio-group>
        <div v-if="input.all_insurance == 'single'" class="mb-4 px-7">
          <div
            v-for="(item, k) in input.insurance_number_list"
            :key="k"
            class="mb-4"
          >
            <ValidationProvider
              :vid="'เลขที่กรมธรรม์' + ' ' + (k + 1)"
              :name="'เลขที่กรมธรรม์'"
              data-vv-as="เลขที่กรมธรรม์"
              :rules="{ required: true, alpha_num: true, exacly8: true }"
              v-slot="{ errors }"
            >
              <v-text-field
                dense
                maxlength="8"
                v-model="input.insurance_number_list[k]"
                label
                onkeypress="return (48 <= event.charCode && event.charCode <= 57) || (65 <= event.charCode && event.charCode <= 90) || (97 <= event.charCode && event.charCode <= 122)"
                outlined
                :error-messages="errors"
                :hide-details="errors.length == 0"
              >
                <template v-slot:append-outer>
                  <v-icon
                    v-if="k == 0"
                    @click="addInsuranceNumber"
                    color="green"
                    >mdi-plus-circle</v-icon
                  >
                  <v-icon
                    v-else
                    @click="input.insurance_number_list.splice(k, 1)"
                    color="red"
                    >mdi-minus-circle</v-icon
                  >
                </template></v-text-field
              >
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div>
        แนบไฟล์เพื่อสำหรับ ยืนยันข้อมูล <span class="red--text">*</span
        ><u
          @click="showExample = true"
          style="cursor: pointer"
          class="blue--text"
          >ตัวอย่าง</u
        >
      </div>
      <v-dialog v-model="showExample">
        <div style="position: relative">
          <v-btn
            fab
            dark
            @click="showExample = false"
            style="position: absolute; right: 10px; top: 10px; z-index: 1"
            color="#5d5d5d9e"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-img
            src="../../assets/example_book_bank.png"
            v-if="input.receive_type != 'prompt_pay'"
          />
          <v-img src="../../assets/example_promtpay.png" v-else />
        </div>
      </v-dialog>
      <div>
        <v-row>
          <v-col :cols="input.receive_type == 'bank_account' ? 6 : 12">
            <ValidationProvider
              name="รูปบัตรประชาชน"
              :rules="{ required: true }"
              v-slot="{ errors }"
            >
              <div style="height: 90px; cursor: pointer">
                <UploadSingleFile
                  :errors="errors"
                  v-model="input.attachment_card_number"
                  :isReturnPath="true"
                  >บัตรประชาชน</UploadSingleFile
                >
              </div>
              <div class="red--text" v-if="errors.length">
                กรุณาอัพโหลด {{ errors[0].replace("กรุณากรอก ", "") }}
              </div>
            </ValidationProvider>
          </v-col>
          <v-col cols="6" v-if="input.receive_type == 'bank_account'">
            <ValidationProvider
              name="หน้าแรกสมุดบัญชี"
              :rules="{ required: true }"
              v-slot="{ errors }"
            >
              <div style="height: 90px; cursor: pointer">
                <UploadSingleFile
                  :errors="errors"
                  v-model="input.attachment_account_number"
                  :isReturnPath="true"
                  >หน้าแรกสมุดบัญชี</UploadSingleFile
                >
              </div>
              <div v-if="errors.length" class="red--text">
                กรุณาอัพโหลด {{ errors[0].replace("กรุณากรอก ", "") }}
              </div>
            </ValidationProvider>
          </v-col>
        </v-row>
      </div>
      <div class="text-center mt-5">
        <v-btn
          :loading="loading"
          @click="next"
          class="px-10"
          color="primary"
          small
          depressed
        >
          <span style="font-size: 18px">ยืนยัน</span>
        </v-btn>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import UploadSingleFile from "@/components/UploadSingleFile.vue";
import axios from "axios";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mask } from "vue-the-mask";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    UploadSingleFile,
  },
  directives: {
    mask,
  },
  data() {
    return {
      loading: false,
      showExample: false,
      input: {
        bank_account_bank: "",
        bank_account_name: "",
        bank_account_number: "",
        all_insurance: "single",
        insurance_number_list: [""],
        attachment_card_number: "",
        attachment_account_number: "",
        receive_type: "",
        card_number: "",
      },
      bankOptions: [
        "ธนาคารกรุงเทพ (BBL)",
        "ธนาคารกรุงไทย (KTB)",
        "ธนาคารกรุงศรีอยุธยา (BAY)",
        "ธนาคารกสิกรไทย (Kbank)",
        "ธนาคารเกียรตินาคิน (Kiatnakin)",
        "ธนาคารซิตี้แบงก์ (CITIBANK)",
        "ธนาคารซีไอเอ็มบี (CIMB)",
        "ธนาคารทหารไทย (TMB)",
        "ธนาคารทิสโก้ (TISCO)",
        "ธนาคารไทยพาณิชย์ (SCB)",
        "ธนาคารธนชาต (Thanachart)",
        "ธนาคารเพื่อการเกษตร  (BAAC)",
        "ธนาคารยูโอบี  (UOB)",
        "ธนาคารสแตนดาร์ดชาร์เตอร์ด (Standard Charterred)",
        "ธนาคารออมสิน (GSB)",
        "ธนาคารไอซีบีซี (ICBC)",
      ],
    };
  },
  mounted() {
    this.input.bank_account_name =
      this.$store.state.input.first_name +
      " " +
      this.$store.state.input.last_name;

    if (this.$store.state.input && this.$store.state.input.receive_type) {
      this.input.receive_type = this.$store.state.input.receive_type;
    }

    if (this.$store.state.input && this.$store.state.input.card_number) {
      this.input.card_number = this.$store.state.input.card_number;
    }
  },
  computed: {
    serverUrl() {
      return this.$store.state.serverUrl;
    },
  },
  methods: {
    addInsuranceNumber() {
      var vm = this;
      this.input.insurance_number_list.unshift("");
      vm.$refs.observer.reset();
      vm.$nextTick(() => {
        vm.$refs.observer.reset();
        vm.$forceUpdate();
      });
    },
    async next() {
      const vm = this;
      try {
        const isValid = await vm.$refs.observer.validate();
        if (isValid) {
          Object.assign(vm.$store.state.input, vm.input);
          if (vm.$store.state.input.all_insurance == "all") {
            vm.$store.state.input.insurance_number_list = [];
          }
          if (vm.input.receive_type == "prompt_pay") {
            vm.input.bank_account_bank = "PROMPTPAY";
            vm.input.bank_account_number = "PROMPTPAY";
          }

          vm.loading = true;
          const data = {
            pageid: vm.$store.state.query.pageid,
            userid: vm.$store.state.profile.userId,
            ...vm.$store.state.input,
            all_insurance: vm.$store.state.input.all_insurance == "all" ? 1 : 0,
            submit_date: moment().format("YYYY-MM-DD HH:mm"),
            card_number: vm.$store.state.input.card_number.toString(),
            phone_number: vm.$store.state.input.phone_number.replace(/-/g, ""),
          };

          const serverToken = this.$store.state.serverToken;

          axios
            .post(vm.serverUrl + "registerbanktransferbenefits", data, {
              headers: {
                AUTHORIZATION: `Bearer xxx ${serverToken}`,
                apikey: serverToken,
                "x-api-key": this.$store.state.serverApiKey,
              },
            })
            .then(async (response) => {
              if (response && response.status === 200) {
                // await vm.sendMessage("ลงทะเบียนขอรับเงินผลประโยชน์เรียบร้อย", {
                //   userid: vm.$store.state.profile.userI,
                //   sessiontoken: "Bearer xxx xxx",
                //   pageid: vm.$store.state.query.pageid,
                // });
                if (vm.$liff.isInClient()) {
                  // eslint-disable-next-line no-undef
                  await vm.$liff.sendMessages([
                    {
                      type: "text",
                      text: "ลงทะเบียนขอรับเงินผลประโยชน์เรียบร้อย",
                    },
                  ]);
                }

                await vm.$swal.fire({
                  icon: "success",
                  text: "ระบบได้รับข้อมูลการลงทะเบียนของท่านเรียบร้อยแล้ว โปรดรอการแจ้งยืนยันผลทาง SMS หลังตรวจสอบข้อมูลเสร็จสิ้น ภายใน 5 วันทำการค่ะ",
                  confirmButtonColor: "#c5281d",
                  confirmButtonText: "ปิด",
                });
                vm.loading = false;
                try {
                  vm.$liff.closeWindow();
                } catch (error) {
                  console.error(error);
                }

                window.close();
                window.location.href = "https://www.generali.co.th/";
              } else {
                await vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                vm.loading = false;
              }
            });
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
